import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAmbivert = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Ambivert Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M16 4V27M16 27C14.0373 27 12.1573 27.3533 10.42 28M16 27C17.9627 27 19.8427 27.3533 21.58 28M29 7.32C27.68 7.04933 26.3467 6.81733 25 6.62667C22.0183 6.20815 19.0109 5.99875 16 6C12.9453 6 9.94 6.21333 7 6.62667C5.65333 6.81733 4.32 7.04933 3 7.32M25 6.62667L28.4933 20.928C28.656 21.5933 28.352 22.2987 27.708 22.5307C26.8392 22.8425 25.923 23.0013 25 23C24.077 23.0013 23.1608 22.8425 22.292 22.5307C21.648 22.2987 21.344 21.5933 21.5053 20.928L25 6.628V6.62667ZM7 6.62667L10.4933 20.928C10.656 21.5933 10.352 22.2987 9.708 22.5307C8.83924 22.8424 7.92301 23.0012 7 23C6.07699 23.0012 5.16076 22.8424 4.292 22.5307C3.648 22.2987 3.344 21.5933 3.50533 20.928L7 6.628V6.62667Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgAmbivert;
